(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('KeywordDetailController', KeywordDetailController);

    KeywordDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Keyword', 'Contract', '$uibModal'];

    function KeywordDetailController($scope, $rootScope, $stateParams, previousState, entity, Keyword, Contract, $uibModal) {
        var vm = this;

        vm.keyword = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:keywordUpdate', function(event, result) {
            vm.keyword = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.createTab = function( data ) {
            $scope.$emit('handleEmit', data );
        };

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.editKeyword = function() {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Keyword', function(Keyword) {
                        return Keyword.get({id : $stateParams.id}).$promise;
                    }]
                }
            }).result.then(function() {

            }, function() {

            });
        };
    }
})();
